export const popupModal = (() => {
    const jsModal = $('.js-modal')
    const vid = document.getElementById("watch-a-video-iframe"); 

    $('.close-modal, .overlay-popup').on( 'click', function() {
        vid.pause();
        const theOpenModalId = $('.modal.is--visible').attr('id');
        //const $frame = $('#watch-a-video-iframe');
        $( '#' + theOpenModalId ).removeClass( 'is--visible' );
        $( '.overlay-popup' ).removeClass('is--visible');
        //$(".start-page__video").pause();
        //$frame.attr('src','');
        //$frame.trigger('pause');
    });

    jsModal.on('click', function(e){
		e.preventDefault;
		const $this = $( this );
        const dataPanelAttr = $this.attr( 'data-modal' );
        $( '#' + dataPanelAttr ).addClass( 'is--visible' );
        $( '.overlay-popup' ).removeClass('overlay--visible');
        $( '.overlay-popup' ).addClass( 'is--visible' );
    });

})();



// WEBPACK FOOTER //
// ./src/components/modal/modal.js